import { FieldHtmlNameUtil, HekateDisplayField, Trans } from 'www-shared';
import { toRefs, watch } from 'vue';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';
import AbstractSubmitSignupScreen from './AbstractSubmitSignupScreen';

export default class EduDetailsEducatorSignupScreen extends AbstractSubmitSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-edu-educator';

  public getThisScreensVisibleComponents(): UnifiedSignupScreenComponent[] {
    const classroomNameHintField = HekateDisplayField.newHintFieldInstance({
      name: Trans.byKey('classroomNameHint'),
    });

    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.schoolName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.classroomName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: classroomNameHintField,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduDepartmentName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduPosition),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.jobTitle),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howDidYouHearAboutUs),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.whatAreYouUsingOnshapeFor),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.acceptedIsEducator),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.acceptedIsClassroom),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.privacyConsentAcceptedStudent),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.recaptcha),
      }),
    ];
  }

  public predicate(): boolean {
    const {
      gradeLevel, persona, chosenPlan, completedDetailsScreens, formSubmitStatus,
    } = this.sessionInfo.value;
    if (formSubmitStatus !== null && formSubmitStatus !== 'submit-failed') {
      return false;
    }
    if (gradeLevel === null || chosenPlan === null || persona == null || !chosenPlan.compareTo(UnifiedSignupPlan.educator)) {
      return false;
    }
    if (completedDetailsScreens.length !== 0) {
      return false;
    }

    return true;
  }

  public async initWatchers(): Promise<void> {
    // map edu position to job title
    const eduPositionVal = toRefs(this.getField(FieldHtmlNameUtil.eduPosition)).val;
    const jobTitleField = this.getField(FieldHtmlNameUtil.jobTitle);
    watch(eduPositionVal, (newVal) => {
      jobTitleField.val = newVal;
    });

    // map schoolname to company name
    const schoolNameVal = toRefs(this.getField(FieldHtmlNameUtil.schoolName)).val;
    const companyNameField = this.getField(FieldHtmlNameUtil.companyName);
    watch(schoolNameVal, (newVal) => {
      companyNameField.val = newVal;
    });
  }
}
